import styles from './ChargingTokenItemDetails.module.css'
import { IFText, IFSelect } from 'Components'
import { Colors } from 'Theme'
import { useTranslation } from 'react-i18next'
import { useState, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import TextField from '@mui/material/TextField'
import { connect } from 'react-redux'
import ChargingTokenDesignActions from 'Stores/ChargingTokenDesign/Actions'
import ChargingTokenActions from 'Stores/ChargingToken/Actions'
import ChargingTokenSelectors from 'Stores/ChargingToken/Selectors'
import ChargingTokenDesignSelectors from 'Stores/ChargingTokenDesign/Selectors'
import VoucherSelectors from 'Stores/Voucher/Selectors'
import VoucherActions from 'Stores/Voucher/Actions'
import RequestState from 'Enums/RequestState'

const ChargingTokenItemDetails = ({
  row,
  editDetails,
  allChargingTokenDesigns,
  onDetailsChange,
  onCancelEdit,
  chargingTokens,
  allVouchers,
  fetchAllChargingTokenDesigns,
  paginationOffset,
  fetchAllChargingTokenDesignsRequestState,
  voucherPaginationOffset,
  fetchAllVouchersRequestState,
  fetchAllVouchers,
  clearVouchers,
  resetAllDesigns,
}) => {
  const { t } = useTranslation()
  const latestTokenDetails = useMemo(() => {
    return chargingTokens.find((token) => token._id === row.original?._id) || {}
  }, [chargingTokens, row])

  const [details, setDetails] = useState({
    reference: latestTokenDetails?.reference || '',
    parentId: latestTokenDetails?.parentId || '',
    design: latestTokenDetails?.design?.name || '',
    voucherCodeName: latestTokenDetails?.voucherDetails?.name,
  })

  useEffect(() => {
    if (latestTokenDetails && Object.keys(latestTokenDetails).length > 0) {
      setDetails({
        reference: latestTokenDetails.reference || '',
        parentId: latestTokenDetails.parentId || '',
        design: latestTokenDetails.design?.name || '',
        voucherCodeName: latestTokenDetails?.voucherDetails?.name,
      })
    }
  }, [latestTokenDetails])

  const resetDetails = () => {
    setDetails({
      reference: row.original?.reference || '',
      parentId: row.original?.parentId || '',
      voucherCodeName: row.original.voucherDetails.name,
      design: row.original?.design?.name || '',
    })
  }

  useEffect(() => {
    if (onCancelEdit) {
      onCancelEdit(resetDetails)
    }
  }, [onCancelEdit])

  const handleInputChange = (key, value) => {
    const updatedDetails = {
      ...details,
      [key]: key === 'voucherCodeName' && value === '' ? '' : value,
    }

    setDetails(updatedDetails)

    const updatedSubmissionDetails = {
      reference: updatedDetails.reference,
      parentId: updatedDetails.parentId,

      voucherCode:
        allVouchers.find(
          (voucher) => voucher.name === updatedDetails.voucherCodeName,
        )?.code || '',
      design:
        allChargingTokenDesigns.find(
          (design) => design.name === updatedDetails.design,
        )?._id || '',
    }

    if (onDetailsChange) {
      onDetailsChange(row.original.id || row.index, updatedSubmissionDetails)
    }
  }

  const ChargingTokenDetails = [
    {
      key: 'ownerType',
      value: latestTokenDetails?.owner?.model,
      translationKey: 'ChargingTokenPage.OwnerType',
    },
    {
      key: 'ownerName',
      value: latestTokenDetails?.owner?.name,
      translationKey: 'ChargingTokenPage.OwnerName',
    },
    {
      key: 'reference',
      value: details.reference,
      translationKey: 'ChargingTokenPage.Reference',
    },
    {
      key: 'parentId',
      value: details.parentId,
      translationKey: 'ChargingTokenPage.ParentID',
    },
    {
      key: 'voucherCodeName',
      value: details.voucherCodeName,
      translationKey: 'ChargingTokenPage.VoucherCode',
    },
    {
      key: 'design',
      value: details.design,
      translationKey: 'ChargingTokenPage.Design',
    },
  ]

  const loadMoreDesignData = () => {
    if (
      fetchAllChargingTokenDesignsRequestState === RequestState.LOADING ||
      paginationOffset === null
    )
      return
    fetchAllChargingTokenDesigns(paginationOffset)
  }

  const loadMoreVoucherData = () => {
    if (
      fetchAllVouchersRequestState === RequestState.LOADING ||
      voucherPaginationOffset === null
    )
      return
    fetchAllVouchers(voucherPaginationOffset)
  }
  useEffect(() => {
    fetchAllChargingTokenDesigns(paginationOffset)
  }, [paginationOffset])
  useEffect(() => {
    fetchAllVouchers(voucherPaginationOffset)
  }, [voucherPaginationOffset])
  return (
    <div
      className={styles.ChargingTokenDetails}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.Line}>
        <div
          style={{ borderLeft: `1px solid ${Colors.DividerColor}` }}
          className={styles.Divider}
        />
        <div
          style={{ background: Colors.DividerColor }}
          className={styles.Circle}
        />
      </div>
      <div className={styles.Details}>
        <div className={styles.ChargingTokenDetailsDiv}>
          <IFText className={styles.ChargingTokenTitle}>
            {t('ChargingTokenPage.Details')}
          </IFText>
          <div className={styles.AllDetails}>
            {ChargingTokenDetails.map((item) => (
              <div className={styles.Detail} key={item.key}>
                <div className={styles.LabelTitle}>
                  <IFText
                    className={styles.DetailText}
                    style={{ color: Colors.DetailPanel }}
                  >
                    {t(item.translationKey)}
                  </IFText>
                </div>
                <div className={styles.LabelValue}>
                  {editDetails && item.key === 'design' ? (
                    <div>
                      <IFSelect
                        cleanable={false}
                        paginationOffset={paginationOffset}
                        size={'sm'}
                        data={allChargingTokenDesigns.map((design) => ({
                          label: design.name,
                          value: design.name,
                        }))}
                        value={details.design}
                        onChange={(selectedValue) =>
                          handleInputChange(item.key, selectedValue)
                        }
                        onSearch={(query) => {
                          fetchAllChargingTokenDesigns(0, query)
                        }}
                        loadMore={() => {
                          loadMoreDesignData()
                        }}
                        loading={
                          fetchAllChargingTokenDesignsRequestState ===
                          RequestState.LOADING
                        }
                        handleMenuClose={() => {
                          resetAllDesigns()
                        }}
                        style={{
                          width: '14rem',
                        }}
                        placeholder={t('ChargingTokenPage.Design')}
                      />
                    </div>
                  ) : editDetails && item.key === 'reference' ? (
                    <TextField
                      size="small"
                      id={`input-${item.key}`}
                      value={item.value}
                      onChange={(e) =>
                        handleInputChange(item.key, e.target.value)
                      }
                      variant="outlined"
                      placeholder={t('ChargingTokenPage.Reference')}
                      sx={{
                        width: '14rem',
                        borderRadius: '8px',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '8px',
                          '& fieldset': {
                            borderColor: Colors.grey,
                            borderRadius: '8px',
                          },
                          '&:hover fieldset': {
                            borderColor: Colors.primary,
                            borderWidth: '1px',
                            borderRadius: '8px',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: Colors.primary,
                            borderWidth: '1px',
                            borderRadius: '8px',
                          },
                        },
                        '& .MuiInputBase-input': {
                          fontSize: '14px',
                          height: '15px',
                        },
                      }}
                    />
                  ) : editDetails && item.key === 'parentId' ? (
                    <TextField
                      size="small"
                      id={`input-${item.key}`}
                      value={item.value}
                      onChange={(e) =>
                        handleInputChange(item.key, e.target.value)
                      }
                      variant="outlined"
                      placeholder={t('ChargingTokenPage.ParentID')}
                      sx={{
                        width: '14rem',
                        borderRadius: '8px',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '8px',
                          '& fieldset': {
                            borderColor: Colors.grey,
                            borderRadius: '8px',
                          },
                          '&:hover fieldset': {
                            borderColor: Colors.primary,
                            borderWidth: '1px',
                            borderRadius: '8px',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: Colors.primary,
                            borderWidth: '1px',
                            borderRadius: '8px',
                          },
                        },

                        '& .MuiInputBase-input': {
                          fontSize: '14px',
                          height: '15px',
                        },
                      }}
                    />
                  ) : editDetails && item.key === 'voucherCodeName' ? (
                    <div>
                      <IFSelect
                        paginationOffset={voucherPaginationOffset}
                        disabled={false}
                        size={'sm'}
                        data={allVouchers.map((voucher) => ({
                          label: voucher.name,
                          value: voucher.code,
                        }))}
                        value={details.voucherCodeName}
                        onChange={(selectedCode) => {
                          const selectedVoucher = allVouchers.find(
                            (voucher) => voucher.code === selectedCode,
                          )
                          handleInputChange(
                            item.key,
                            selectedVoucher ? selectedVoucher.name : '',
                          )
                        }}
                        onSearch={(query) => {
                          fetchAllVouchers(0, query)
                        }}
                        loadMore={() => {
                          loadMoreVoucherData()
                        }}
                        handleMenuClose={() => {
                          clearVouchers()
                        }}
                        loading={
                          fetchAllVouchersRequestState === RequestState.LOADING
                        }
                        style={{
                          width: '14rem',
                        }}
                        placeholder={t('ChargingTokenPage.VoucherCode')}
                      />
                    </div>
                  ) : item.value ? (
                    <IFText className={styles.DetailText}>{item.value}</IFText>
                  ) : (
                    <IFText className={styles.DetailText}>
                      {t('ChargingTokenPage.NotSet')}
                    </IFText>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  createChargingTokenRequestState:
    ChargingTokenSelectors.getCreateChargingTokenRequestState(state),

  createChargingTokenBulkRequestState:
    ChargingTokenSelectors.getCreateChargingTokenBulkRequestState(state),
  downloadChargingTokenSampleFileRequestState:
    ChargingTokenSelectors.getDownloadChargingTokenSampleFileRequestState(
      state,
    ),
  paginationOffset: ChargingTokenDesignSelectors.getPaginationOffset(state),
  fetchAllChargingTokenDesignsRequestState:
    ChargingTokenDesignSelectors.getFetchAllChargingTokenDesignsRequestState(
      state,
    ),
  voucherPaginationOffset: VoucherSelectors.getPaginationOffset(state),
  fetchAllVouchersRequestState:
    VoucherSelectors.getFetchAllVouchersRequestState(state),
})

function mapDispatchToProps(dispatch) {
  return {
    createChargingTokenBulk: (chargingToken) =>
      dispatch(ChargingTokenActions.createChargingTokenBulk(chargingToken)),

    createChargingToken: (values) =>
      dispatch(ChargingTokenActions.createChargingToken(values)),
    fetchAllChargingTokenDesigns: (offset, designName) =>
      dispatch(
        ChargingTokenDesignActions.fetchAllChargingTokenDesigns(
          offset,
          designName,
        ),
      ),
    downloadChargingTokenSampleFile: () =>
      dispatch(ChargingTokenActions.downloadChargingTokenSampleFile()),
    fetchAllVouchers: (offset, voucherName) =>
      dispatch(VoucherActions.fetchAllVouchers(offset, voucherName)),
    clearVouchers: () => dispatch(VoucherActions.clearVouchers()),
    resetAllDesigns: () =>
      dispatch(ChargingTokenDesignActions.resetAllDesigns()),
  }
}

ChargingTokenItemDetails.propTypes = {
  row: PropTypes.object,
  editDetails: PropTypes.bool,
  allChargingTokenDesigns: PropTypes.object,
  onDetailsChange: PropTypes.func,
  onCancelEdit: PropTypes.func,
  chargingTokens: PropTypes.array,
  allVouchers: PropTypes.array,
  fetchAllChargingTokenDesigns: PropTypes.func,
  paginationOffset: PropTypes.number,
  fetchAllChargingTokenDesignsRequestState: PropTypes.number,
  voucherPaginationOffset: PropTypes.number,
  fetchAllVouchersRequestState: PropTypes.number,
  fetchAllVouchers: PropTypes.func,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChargingTokenItemDetails)
